import Component from './InstagramInstantwinAnalyticsPublicSummary.vue'
export default Component
